var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.366 19.6215L4.7805 15.417H9.99L11.406 19.6215H13.29L8.31 5.625H6.483L1.5 19.6215H3.366V19.6215ZM7.416 7.737L9.51 13.971H5.265L7.365 7.737H7.416V7.737ZM21.135 18.2775H21.1875V19.6215H22.8795V12.1875C22.8795 9.9225 21.2085 8.67 18.9105 8.67C16.3065 8.67 15.0255 10.044 14.9115 11.931H16.5735C16.6755 10.854 17.466 10.146 18.849 10.146C20.3055 10.146 21.126 10.926 21.126 12.342V13.4385H18.285C15.8145 13.449 14.502 14.6385 14.502 16.5255C14.502 18.504 15.9375 19.7955 18.0195 19.7955C19.6095 19.7955 20.5935 19.1505 21.1365 18.279L21.135 18.2775ZM18.4905 18.33C17.3625 18.33 16.3065 17.7345 16.3065 16.464C16.3065 15.489 16.9425 14.7915 18.4185 14.7915H21.126V16.0425C21.126 17.3865 19.998 18.33 18.4905 18.33Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSettings);
export default __webpack_public_path__ + "static/media/font-settings.eae4f9d86e49d386506836b79e76213e.svg";
export { ForwardRef as ReactComponent };